import React from "react";
import { withRouter } from "react-router";
import NegocioAgregarCadete from "./NegocioAgregarCadete";
const BetaEditarCadete = props => {
    return <NegocioAgregarCadete editar={true} />;
};

export default withRouter(BetaEditarCadete);
